module.exports = __webpack_public_path__ + "img/P150T_weapon_26.e0d54c64.png";